export default "__VITE_ASSET__DHANsqRL__"